import { getSrcs } from '@helpers/image';
import { withMotionMax } from '@hoc/withMotionMax';
import CarouselProvider from '@stories/Components/Carousels/Carousel/CarouselProvider/CarouselProvider';
import MotionTrack from '@stories/Components/Carousels/Carousel/MotionTrack/MotionTrack';
import Pagination from '@stories/Components/Carousels/Carousel/Pagination/Pagination';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import S from './Gallery.styles';
const Gallery = (props) => {
    const getOrientationSrcs = (item) => {
        if (item.orientation === 'landscape') {
            return getSrcs(item.image, 1020, 336, 5, 1020 / 680);
        }
        else if (item.orientation === 'portrait') {
            return getSrcs(item.image, 503, 166, 5, 503 / 680);
        }
        else {
            return [];
        }
    };
    return (React.createElement(MotionConfig, { transition: { duration: 0.35, ease: 'easeOut' } },
        React.createElement(CarouselProvider, { paddingOffset: 0, count: props.items.length },
            React.createElement(S.Container, { id: props.anchorId, spacing: "padding" },
                React.createElement(S.Title, { "data-alignment": props.titleAlignment }, props.title),
                React.createElement(S.CarouselWrapper, null,
                    React.createElement(MotionTrack, null, props.items.map((item, index) => (React.createElement(S.Item, { key: `gallery-image-${index}`, "data-image-orientation": item.orientation },
                        React.createElement(S.ImageWrapper, null,
                            React.createElement(S.Img, { src: getOrientationSrcs(item)[0].split(' ')[0], srcSet: getOrientationSrcs(item).join(','), sizes: "100vw", alt: item.image.altText ?? undefined, role: !item.image.altText ? 'presentation' : undefined, loading: 'lazy' }))))))),
                React.createElement(S.ControlsWrapper, null,
                    React.createElement(Pagination, { altTheme: true }))))));
};
export default withMotionMax(Gallery);
